import React, { useMemo, useRef, useState } from "react";

export default function AssetUploadPanel({ open, onClose, supabaseEnabled, onInsert }) {
    const fileInputRef = useRef(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [urlValue, setUrlValue] = useState("");
    const [altValue, setAltValue] = useState("");
    const [status, setStatus] = useState("");

    const pendingCount = useMemo(() => selectedFiles.length, [selectedFiles]);

    if (!open) {
        return null;
    }

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files ?? []);
        setSelectedFiles(files);
        if (!files.length) {
            setStatus("");
            return;
        }
        if (!supabaseEnabled) {
            setStatus("Dosyalar seçildi ancak storage henüz bağlı değil. VPS storage aktif olduğunda bu panelden yükleyebilirsiniz.");
        } else {
            setStatus(`${files.length} dosya seçildi. Yükleme bağlantısı yapılandırıldığında buradan aktarabilirsiniz.`);
        }
    };

    const handleTriggerInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleResetFiles = () => {
        setSelectedFiles([]);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleInsertUrl = () => {
        if (!urlValue.trim()) {
            setStatus("Önce bir URL girin.");
            return;
        }
        onInsert(urlValue.trim(), altValue.trim());
        setUrlValue("");
        setAltValue("");
        setStatus("URL galeriye eklendi.");
    };

    return (
        <div className="asset-panel">
            <div className="asset-panel__backdrop" role="presentation" onClick={onClose} />
            <div className="asset-panel__content" role="dialog" aria-modal="true" aria-label="Fotoğraf yükleme paneli">
                <header className="asset-panel__header">
                    <h3 className="asset-panel__title">Fotoğraf yükleme paneli</h3>
                    <p className="asset-panel__subtitle">
                        VPS storage tamamlandığında dosya yükleme adımını buradan gerçekleştireceksiniz. Şimdilik URL yapıştırarak galeriyi güncelleyebilirsiniz.
                    </p>
                </header>

                <section className="asset-panel__section">
                    <h4 className="asset-panel__section-title">Dosya yükleme (hazırlık)</h4>
                    <p className="asset-panel__section-hint">
                        {supabaseEnabled
                            ? "Supabase bağlantısı aktif. Storage ayarları yapıldığında yüklemeyi burada tamamlayacağız."
                            : "Supabase storage henüz bağlı değil. Dosyalar VPS storage sağlandığında buradan aktarılacak."}
                    </p>
                    <div className="asset-panel__dropzone" onClick={handleTriggerInput} role="button" tabIndex={0}>
                        <input
                            ref={fileInputRef}
                            type="file"
                            multiple
                            className="asset-panel__hidden-input"
                            onChange={handleFileChange}
                        />
                        <p>
                            Dosya seçmek için tıklayın veya bu alana sürükleyin. Şimdilik dosyalar yalnızca önizleme için listelenir.
                        </p>
                        {pendingCount > 0 && <span className="asset-panel__tag">{pendingCount} dosya seçildi</span>}
                    </div>
                    {pendingCount > 0 && (
                        <div className="asset-panel__file-list">
                            {selectedFiles.map((file) => (
                                <div key={file.name} className="asset-panel__file-row">
                                    <span>{file.name}</span>
                                    <span className="asset-panel__file-size">{Math.round(file.size / 1024)} KB</span>
                                </div>
                            ))}
                        </div>
                    )}
                    {pendingCount > 0 && (
                        <button type="button" className="asset-panel__button" onClick={handleResetFiles}>
                            Seçimi temizle
                        </button>
                    )}
                </section>

                <section className="asset-panel__section">
                    <h4 className="asset-panel__section-title">Galeriye URL ekle</h4>
                    <div className="asset-panel__form">
                        <label className="asset-panel__label" htmlFor="asset-panel-url">
                            Görsel URL
                        </label>
                        <input
                            id="asset-panel-url"
                            className="asset-panel__input"
                            value={urlValue}
                            onChange={(event) => setUrlValue(event.target.value)}
                            placeholder="https://..."
                        />
                        <label className="asset-panel__label" htmlFor="asset-panel-alt">
                            Açıklama (alt metin)
                        </label>
                        <input
                            id="asset-panel-alt"
                            className="asset-panel__input"
                            value={altValue}
                            onChange={(event) => setAltValue(event.target.value)}
                            placeholder="Örn. Render açıklaması"
                        />
                        <button type="button" className="asset-panel__button asset-panel__button--primary" onClick={handleInsertUrl}>
                            Galeriye ekle
                        </button>
                    </div>
                </section>

                {status && <p className="asset-panel__status">{status}</p>}

                <footer className="asset-panel__footer">
                    <button type="button" className="asset-panel__button" onClick={onClose}>
                        Paneli kapat
                    </button>
                </footer>
            </div>
        </div>
    );
}
